import consts, { TypeCanvasElement } from "shared/consts";

const elementsValues = Object.values(consts.CANVAS_ELEMENTS).reduce((acc: Record<string, false>, element: string) => {
  acc[`canvas-element-${element}`] = false;
  return acc;
}, {}) as Record<`canvas-element-${TypeCanvasElement}`, false>;

export const AB_TEST_KEY = "ab-test";

export const DefaultFeatureFlagsValues = {
  "test-flag": false,
  "test-variant": { temp: "temp" },
  ...elementsValues,
  "org-chart-walkthrough": false,
  "per-seat-license": null,
  "restrict-free-canvas-elements": { elementsNumber: 10 },
  "cursor-visibility-control": false,
  "orgchart-filters-column-dropdown": false,
  "orgchart-department-enabled": false,
  "gantt-monday-integration-items": false,
  "gantt-monday-dependency-column": false,
  "stickynote-on-double-click": false,
  "gantt-monday-split-rows": false,
  "restricted-columns": false,
  "reduce-org-chart-loading-time": false,
  "element-data-layer": false,
  "disable-task-assignee": false,
  "monday-item-from-task-card": false,
  "monday-item-from-gantt-card": false,
  "new-accounts": false,
  "canvas-element-new-link-badge": false,
  "ai-features": false,
  "new-dragging-experience": false,
  "cim-dev-tools": false,
  "cim-presentation-mode": false,
  "upload-pdf": false,
  "cim-footer": false,
  "orgchart-extended-fields": false,
  "new-transformer-design": false,
  "cim-reorder": false,
  "zoom-and-pan-performance": false,
  "new-task-element": false,
  "new-monday-task-element": false,
  "cim-reorder-import-monday-items": false,
  "cim-onboarding": false,
  "cim-new-template-gallery": false,
  "cim-new-default-sizes": false,
  "cim-synced-widgets": false,
  "use-monday-sdk": false,
  "ai-edits": false,
  "cim-new-floaters-style": false,
  "templates-auto-placement": false,
  "ai-feedback": false,
  "cim-incognito-page": false,
};

export type FeatureFlagsKeys = keyof typeof DefaultFeatureFlagsValues | `canvas-element-${TypeCanvasElement}`;

export type FeatureFlagValue<K extends FeatureFlagsKeys> = typeof DefaultFeatureFlagsValues[K];

export type FeatureFlagsValues = typeof DefaultFeatureFlagsValues;
